import { PermissionModel } from './permission.model';

export class PermissionNodeModel extends PermissionModel {
    declare groupTitle: string;
    items: PermissionNodeModel[] = [];
    isExpanded?: boolean;

    constructor(init: Partial<PermissionNodeModel>) {
        super();
        Object.assign(this, init);
    }
}
